// extracted by mini-css-extract-plugin
export default {"Password":"RegistrationForm_Password__aaiyb","Error":"RegistrationForm_Error__jwtMx","RegisterButton":"RegistrationForm_RegisterButton__khRZV"};